module.exports = __webpack_public_path__ + "static/vpn_p-0cd53d9a363faed478f048005c463968.png";